import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default stripePromise;

export const STRIPE_PRICES = {
  essential: process.env.REACT_APP_STRIPE_PRICE_ESSENTIAL,
  pro: process.env.REACT_APP_STRIPE_PRICE_PRO,
  enterprise: process.env.REACT_APP_STRIPE_PRICE_ENTERPRISE
};